import { Autocomplete } from "@mui/material";
import { useState } from "react";

import FilterTypes from "./FilterTypes/FilterTypes";
import InputFinder from "./InputFinder";
// components
import Option from "./Option";
import SearchNotFound from "./SearchNotFound";
// service
import useGetSecuritiest, { SecurityType } from "./useGetSecuritiest";

// ----------------------------------------------------------------------

interface Props {
	value?: SecurityType;
	onChange: (newValue: SecurityType) => void;
}

export default function InputSearch({ onChange, value }: Props) {
	const [open, setOpen] = useState(false);

	const { data = [], onInputChange, loading, term, onFilterChange, filter } = useGetSecuritiest();

	function onChangeSelect(_: any, value: SecurityType | null) {
		if (value === null) onChange({} as SecurityType);
		else onChange(value);
	}

	function onSetCustomValue() {
		onChange({ name: term } as SecurityType);
		setOpen(false);
	}

	return (
		<Autocomplete
			autoHighlight
			filterOptions={(options) => options}
			fullWidth
			getOptionLabel={({ name }: SecurityType) => name}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			loading={loading}
			size='small'
			noOptionsText={
				<>
					{term && (
						<FilterTypes
							filterSelected={filter}
							onFilterChange={onFilterChange}
							isEmpty={data.length === 0}
						/>
					)}
					<SearchNotFound onClickCustomValue={onSetCustomValue} sx={{ mt: 2 }} term={term} />
				</>
			}
			onChange={onChangeSelect}
			onClose={() => setOpen(false)}
			onInputChange={onInputChange}
			onOpen={() => setOpen(true)}
			open={open}
			options={[...data]}
			popupIcon={null}
			renderInput={(params) => <InputFinder {...params} />}
			renderOption={(props, option, { inputValue }) => {
				const isFirst = data[0].id === option.id;
				return (
					<>
						{isFirst && (
							<FilterTypes
								filterSelected={filter}
								onFilterChange={onFilterChange}
								isEmpty={data.length === 0}
							/>
						)}
						<li
							{...props}
							key={option.id}
							style={{
								minWidth: "100%",
								marginTop: isFirst ? 70 : 0
							}}
						>
							<Option {...option} term={inputValue} />
						</li>
					</>
				);
			}}
			value={value}
		/>
	);
}
